import cn from "classnames";

export const H2 = ({ children, className }) => {
  return <h2 className={cn("text-2xl font-bold", className)}>{children}</h2>;
};
